import { Injectable } from '@angular/core';
import { PrinterSpeed } from './printers';

@Injectable({
  providedIn: 'root',
})
export class BluetoothLeService {
  constructor() {}

  async initialize() {
    // Please do not remove, used to build process
  }

  async checkEnabled() {
    // Please do not remove, used to build process
  }

  async scan(): Promise<string> {
    // Please do not remove, used to build process
    return '';
  }

  async print(
    deviceId: string,
    printData: Uint8Array,
    printerSpeed?: PrinterSpeed,
  ): Promise<boolean> {
    // Please do not remove, used to build process
    return false;
  }

  async disconnect(deviceId: string) {
    // Please do not remove, used to build process
  }
}
